import React from 'react'

function BtnDefault({socialMedia, link}) {
  return (
    <a href={link} target='__black' rel='noopener noreferrer'>
      <button className='btn-default'>Ver conta de Raffa no {socialMedia}</button>
    </a>
  )
}

export default BtnDefault
